export default __webpack_public_path__ + "static/Group 12197-0cda25e25c8e15574bda8a56f2a4e04c.png";